import { render, staticRenderFns } from "./AddQuestionModal.vue?vue&type=template&id=492a1a4a&"
import script from "./AddQuestionModal.vue?vue&type=script&lang=js&"
export * from "./AddQuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./AddQuestionModal.vue?vue&type=style&index=0&id=492a1a4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports